<app-shared-business-metadata-v2 [metadata]="metadata" />

<app-card class="flex-basis-100 mb-12" *ngIf="hasBasicInfo()">
  <div cardTitle i18n>Informations Choses d'Entreprise</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          metadata?.reimbursedSum !== undefined ||
          originalMetadata?.reimbursedSum !== undefined
        "
      >
        <span class="card__label" i18n>Franchise (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.reimbursedSum !== metadata.reimbursedSum,
            }"
            >{{ metadata.reimbursedSum }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.reimbursedSum !== metadata.reimbursedSum &&
              originalMetadata.reimbursedSum !== null &&
              originalMetadata.reimbursedSum !== undefined
            "
            >{{ originalMetadata.reimbursedSum }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.insuredSum !== undefined ||
          originalMetadata?.insuredSum !== undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.insuredSum !== metadata.insuredSum,
            }"
            >{{ metadata.insuredSum }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.insuredSum !== metadata.insuredSum &&
              originalMetadata.insuredSum !== null &&
              originalMetadata.insuredSum !== undefined
            "
            >{{ originalMetadata.insuredSum }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.insuredObjects?.length ||
          originalMetadata?.insuredObjects?.length
        "
      >
        <span class="card__label" i18n>Objets assurés</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getInsuredObjectsText(originalMetadata.insuredObjects) !==
                  getInsuredObjectsText(metadata.insuredObjects),
            }"
            >{{ getInsuredObjectsText(metadata.insuredObjects) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getInsuredObjectsText(originalMetadata.insuredObjects) !==
                getInsuredObjectsText(metadata.insuredObjects) &&
              getInsuredObjectsText(originalMetadata.insuredObjects) !== null &&
              getInsuredObjectsText(originalMetadata.insuredObjects) !==
                undefined
            "
            >{{ getInsuredObjectsText(originalMetadata.insuredObjects) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.otherObject || originalMetadata?.otherObject"
      >
        <span class="card__label" i18n>Autre objet</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.otherObject !== metadata.otherObject,
            }"
            >{{ metadata.otherObject }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.otherObject !== metadata.otherObject &&
              originalMetadata.otherObject !== null &&
              originalMetadata.otherObject !== undefined
            "
            >{{ originalMetadata.otherObject }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isFireDamageCoverageEmpty(metadata?.fireDamageCoverage) ||
    !isFireDamageCoverageEmpty(originalMetadata?.fireDamageCoverage)
  "
>
  <div cardTitle i18n>Incendie</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage !== null &&
            metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage !==
              undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage !==
            null &&
            originalMetadata?.fireDamageCoverage
              ?.fireNaturalDisasterCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Incendie et événements naturels</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.fireDamageCoverage
                    .fireNaturalDisasterCoverage
                ) !==
                  getBooleanLabel(
                    metadata.fireDamageCoverage.fireNaturalDisasterCoverage
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.fireDamageCoverage.fireNaturalDisasterCoverage
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.fireDamageCoverage.fireNaturalDisasterCoverage
              ) !==
                getBooleanLabel(
                  metadata.fireDamageCoverage.fireNaturalDisasterCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.fireDamageCoverage.fireNaturalDisasterCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.fireDamageCoverage.fireNaturalDisasterCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.fireDamageCoverage.fireNaturalDisasterCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.dicDilCoverage !== null &&
            metadata?.fireDamageCoverage?.dicDilCoverage !== undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage?.dicDilCoverage !== null &&
            originalMetadata?.fireDamageCoverage?.dicDilCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture DIC/DIL</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.fireDamageCoverage.dicDilCoverage
                ) !==
                  getBooleanLabel(metadata.fireDamageCoverage.dicDilCoverage),
            }"
            >{{
              getBooleanLabel(metadata.fireDamageCoverage.dicDilCoverage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.fireDamageCoverage.dicDilCoverage
              ) !==
                getBooleanLabel(metadata.fireDamageCoverage.dicDilCoverage) &&
              getBooleanLabel(
                originalMetadata.fireDamageCoverage.dicDilCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.fireDamageCoverage.dicDilCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.fireDamageCoverage.dicDilCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.insuredSum !== undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage?.insuredSum !== undefined)
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.fireDamageCoverage.insuredSum !==
                  metadata.fireDamageCoverage.insuredSum,
            }"
            >{{ metadata.fireDamageCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.fireDamageCoverage.insuredSum !==
                metadata.fireDamageCoverage.insuredSum &&
              originalMetadata.fireDamageCoverage.insuredSum !== null &&
              originalMetadata.fireDamageCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.fireDamageCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.value !== undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage?.value !== undefined)
        "
      >
        <span class="card__label" i18n>Valeur</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessCompanyThingValueLabel(
                  originalMetadata.fireDamageCoverage.value
                ) !==
                  getBusinessCompanyThingValueLabel(
                    metadata.fireDamageCoverage.value
                  ),
            }"
            >{{
              getBusinessCompanyThingValueLabel(
                metadata.fireDamageCoverage.value
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.fireDamageCoverage.value
              ) !==
                getBusinessCompanyThingValueLabel(
                  metadata.fireDamageCoverage.value
                ) &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.fireDamageCoverage.value
              ) !== null &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.fireDamageCoverage.value
              ) !== undefined
            "
            >{{
              getBusinessCompanyThingValueLabel(
                originalMetadata.fireDamageCoverage.value
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.fireDeductible !== undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage?.fireDeductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise en incendie</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.fireDamageCoverage.fireDeductible !==
                  metadata.fireDamageCoverage.fireDeductible,
            }"
            >{{ metadata.fireDamageCoverage.fireDeductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.fireDamageCoverage.fireDeductible !==
                metadata.fireDamageCoverage.fireDeductible &&
              originalMetadata.fireDamageCoverage.fireDeductible !== null &&
              originalMetadata.fireDamageCoverage.fireDeductible !== undefined
            "
            >{{ originalMetadata.fireDamageCoverage.fireDeductible }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.specialFees !== undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage?.specialFees !== undefined)
        "
      >
        <span class="card__label" i18n>Choses spéciales et frais</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.fireDamageCoverage.specialFees !==
                  metadata.fireDamageCoverage.specialFees,
            }"
            >{{ metadata.fireDamageCoverage.specialFees }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.fireDamageCoverage.specialFees !==
                metadata.fireDamageCoverage.specialFees &&
              originalMetadata.fireDamageCoverage.specialFees !== null &&
              originalMetadata.fireDamageCoverage.specialFees !== undefined
            "
            >{{ originalMetadata.fireDamageCoverage.specialFees }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.contingencyInsurance !== undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage?.contingencyInsurance !==
              undefined)
        "
      >
        <span class="card__label" i18n>Assurance prévisionnelle</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.fireDamageCoverage.contingencyInsurance !==
                  metadata.fireDamageCoverage.contingencyInsurance,
            }"
            >{{ metadata.fireDamageCoverage.contingencyInsurance }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.fireDamageCoverage.contingencyInsurance !==
                metadata.fireDamageCoverage.contingencyInsurance &&
              originalMetadata.fireDamageCoverage.contingencyInsurance !==
                null &&
              originalMetadata.fireDamageCoverage.contingencyInsurance !==
                undefined
            "
            >{{
              originalMetadata.fireDamageCoverage.contingencyInsurance
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.externalInsurance !== undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage?.externalInsurance !==
              undefined)
        "
      >
        <span class="card__label" i18n>Assurance externe</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.fireDamageCoverage.externalInsurance !==
                  metadata.fireDamageCoverage.externalInsurance,
            }"
            >{{ metadata.fireDamageCoverage.externalInsurance }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.fireDamageCoverage.externalInsurance !==
                metadata.fireDamageCoverage.externalInsurance &&
              originalMetadata.fireDamageCoverage.externalInsurance !== null &&
              originalMetadata.fireDamageCoverage.externalInsurance !==
                undefined
            "
            >{{ originalMetadata.fireDamageCoverage.externalInsurance }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.constructionHutTools !== undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage?.constructionHutTools !==
              undefined)
        "
      >
        <span class="card__label" i18n>Outils dans baraques de chantier</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.fireDamageCoverage.constructionHutTools !==
                  metadata.fireDamageCoverage.constructionHutTools,
            }"
            >{{ metadata.fireDamageCoverage.constructionHutTools }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.fireDamageCoverage.constructionHutTools !==
                metadata.fireDamageCoverage.constructionHutTools &&
              originalMetadata.fireDamageCoverage.constructionHutTools !==
                null &&
              originalMetadata.fireDamageCoverage.constructionHutTools !==
                undefined
            "
            >{{
              originalMetadata.fireDamageCoverage.constructionHutTools
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.internalDisturbances !== undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage?.internalDisturbances !==
              undefined)
        "
      >
        <span class="card__label" i18n>Troubles intérieurs / E.C.</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.fireDamageCoverage.internalDisturbances !==
                  metadata.fireDamageCoverage.internalDisturbances,
            }"
            >{{ metadata.fireDamageCoverage.internalDisturbances }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.fireDamageCoverage.internalDisturbances !==
                metadata.fireDamageCoverage.internalDisturbances &&
              originalMetadata.fireDamageCoverage.internalDisturbances !==
                null &&
              originalMetadata.fireDamageCoverage.internalDisturbances !==
                undefined
            "
            >{{
              originalMetadata.fireDamageCoverage.internalDisturbances
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.internalDistrubancesDeductible !==
              undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage
              ?.internalDistrubancesDeductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise en E.C.</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.fireDamageCoverage
                  .internalDistrubancesDeductible !==
                  metadata.fireDamageCoverage.internalDistrubancesDeductible,
            }"
            >{{
              metadata.fireDamageCoverage.internalDistrubancesDeductible
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.fireDamageCoverage
                .internalDistrubancesDeductible !==
                metadata.fireDamageCoverage.internalDistrubancesDeductible &&
              originalMetadata.fireDamageCoverage
                .internalDistrubancesDeductible !== null &&
              originalMetadata.fireDamageCoverage
                .internalDistrubancesDeductible !== undefined
            "
            >{{
              originalMetadata.fireDamageCoverage.internalDistrubancesDeductible
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.monetaryValues !== undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage?.monetaryValues !== undefined)
        "
      >
        <span class="card__label" i18n>Valeurs pécuniaires</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.fireDamageCoverage.monetaryValues !==
                  metadata.fireDamageCoverage.monetaryValues,
            }"
            >{{ metadata.fireDamageCoverage.monetaryValues }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.fireDamageCoverage.monetaryValues !==
                metadata.fireDamageCoverage.monetaryValues &&
              originalMetadata.fireDamageCoverage.monetaryValues !== null &&
              originalMetadata.fireDamageCoverage.monetaryValues !== undefined
            "
            >{{ originalMetadata.fireDamageCoverage.monetaryValues }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireDamageCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.fireDamageCoverage?.monetaryValuesInSafe !== undefined) ||
          (originalMetadata?.fireDamageCoverage?.fireNaturalDisasterCoverage ===
            true &&
            originalMetadata?.fireDamageCoverage?.monetaryValuesInSafe !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Valeurs pécuniaires dans les coffres-forts</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.fireDamageCoverage.monetaryValuesInSafe !==
                  metadata.fireDamageCoverage.monetaryValuesInSafe,
            }"
            >{{ metadata.fireDamageCoverage.monetaryValuesInSafe }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.fireDamageCoverage.monetaryValuesInSafe !==
                metadata.fireDamageCoverage.monetaryValuesInSafe &&
              originalMetadata.fireDamageCoverage.monetaryValuesInSafe !==
                null &&
              originalMetadata.fireDamageCoverage.monetaryValuesInSafe !==
                undefined
            "
            >{{
              originalMetadata.fireDamageCoverage.monetaryValuesInSafe
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isBasicCoverageEmpty(metadata?.earthquakeCoverage) ||
    !isBasicCoverageEmpty(originalMetadata?.earthquakeCoverage)
  "
>
  <div cardTitle i18n>Tremblement de terre</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.earthquakeCoverage?.coverage !== null &&
            metadata?.earthquakeCoverage?.coverage !== undefined) ||
          (originalMetadata?.earthquakeCoverage?.coverage !== null &&
            originalMetadata?.earthquakeCoverage?.coverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture tremblement de terre</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.earthquakeCoverage.coverage
                ) !== getBooleanLabel(metadata.earthquakeCoverage.coverage),
            }"
            >{{ getBooleanLabel(metadata.earthquakeCoverage.coverage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.earthquakeCoverage.coverage) !==
                getBooleanLabel(metadata.earthquakeCoverage.coverage) &&
              getBooleanLabel(originalMetadata.earthquakeCoverage.coverage) !==
                null &&
              getBooleanLabel(originalMetadata.earthquakeCoverage.coverage) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.earthquakeCoverage.coverage)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.earthquakeCoverage?.coverage === true &&
            metadata?.earthquakeCoverage?.insuredSum !== undefined) ||
          (originalMetadata?.earthquakeCoverage?.coverage === true &&
            originalMetadata?.earthquakeCoverage?.insuredSum !== undefined)
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.earthquakeCoverage.insuredSum !==
                  metadata.earthquakeCoverage.insuredSum,
            }"
            >{{ metadata.earthquakeCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.earthquakeCoverage.insuredSum !==
                metadata.earthquakeCoverage.insuredSum &&
              originalMetadata.earthquakeCoverage.insuredSum !== null &&
              originalMetadata.earthquakeCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.earthquakeCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.earthquakeCoverage?.coverage === true &&
            metadata?.earthquakeCoverage?.value !== undefined) ||
          (originalMetadata?.earthquakeCoverage?.coverage === true &&
            originalMetadata?.earthquakeCoverage?.value !== undefined)
        "
      >
        <span class="card__label" i18n>Valeur</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessCompanyThingValueLabel(
                  originalMetadata.earthquakeCoverage.value
                ) !==
                  getBusinessCompanyThingValueLabel(
                    metadata.earthquakeCoverage.value
                  ),
            }"
            >{{
              getBusinessCompanyThingValueLabel(
                metadata.earthquakeCoverage.value
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.earthquakeCoverage.value
              ) !==
                getBusinessCompanyThingValueLabel(
                  metadata.earthquakeCoverage.value
                ) &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.earthquakeCoverage.value
              ) !== null &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.earthquakeCoverage.value
              ) !== undefined
            "
            >{{
              getBusinessCompanyThingValueLabel(
                originalMetadata.earthquakeCoverage.value
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.earthquakeCoverage?.coverage === true &&
            metadata?.earthquakeCoverage?.deductible !== undefined) ||
          (originalMetadata?.earthquakeCoverage?.coverage === true &&
            originalMetadata?.earthquakeCoverage?.deductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.earthquakeCoverage.deductible !==
                  metadata.earthquakeCoverage.deductible,
            }"
            >{{ metadata.earthquakeCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.earthquakeCoverage.deductible !==
                metadata.earthquakeCoverage.deductible &&
              originalMetadata.earthquakeCoverage.deductible !== null &&
              originalMetadata.earthquakeCoverage.deductible !== undefined
            "
            >{{ originalMetadata.earthquakeCoverage.deductible }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isBasicCoverageEmpty(metadata?.terrorismCoverage) ||
    !isBasicCoverageEmpty(originalMetadata?.terrorismCoverage)
  "
>
  <div cardTitle i18n>Terrorisme</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.terrorismCoverage?.coverage !== null &&
            metadata?.terrorismCoverage?.coverage !== undefined) ||
          (originalMetadata?.terrorismCoverage?.coverage !== null &&
            originalMetadata?.terrorismCoverage?.coverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture terrorisme</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.terrorismCoverage.coverage) !==
                  getBooleanLabel(metadata.terrorismCoverage.coverage),
            }"
            >{{ getBooleanLabel(metadata.terrorismCoverage.coverage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.terrorismCoverage.coverage) !==
                getBooleanLabel(metadata.terrorismCoverage.coverage) &&
              getBooleanLabel(originalMetadata.terrorismCoverage.coverage) !==
                null &&
              getBooleanLabel(originalMetadata.terrorismCoverage.coverage) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.terrorismCoverage.coverage)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.terrorismCoverage?.coverage === true &&
            metadata?.terrorismCoverage?.insuredSum !== undefined) ||
          (originalMetadata?.terrorismCoverage?.coverage === true &&
            originalMetadata?.terrorismCoverage?.insuredSum !== undefined)
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.terrorismCoverage.insuredSum !==
                  metadata.terrorismCoverage.insuredSum,
            }"
            >{{ metadata.terrorismCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.terrorismCoverage.insuredSum !==
                metadata.terrorismCoverage.insuredSum &&
              originalMetadata.terrorismCoverage.insuredSum !== null &&
              originalMetadata.terrorismCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.terrorismCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.terrorismCoverage?.coverage === true &&
            metadata?.terrorismCoverage?.value !== undefined) ||
          (originalMetadata?.terrorismCoverage?.coverage === true &&
            originalMetadata?.terrorismCoverage?.value !== undefined)
        "
      >
        <span class="card__label" i18n>Valeur</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessCompanyThingValueLabel(
                  originalMetadata.terrorismCoverage.value
                ) !==
                  getBusinessCompanyThingValueLabel(
                    metadata.terrorismCoverage.value
                  ),
            }"
            >{{
              getBusinessCompanyThingValueLabel(
                metadata.terrorismCoverage.value
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.terrorismCoverage.value
              ) !==
                getBusinessCompanyThingValueLabel(
                  metadata.terrorismCoverage.value
                ) &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.terrorismCoverage.value
              ) !== null &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.terrorismCoverage.value
              ) !== undefined
            "
            >{{
              getBusinessCompanyThingValueLabel(
                originalMetadata.terrorismCoverage.value
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.terrorismCoverage?.coverage === true &&
            metadata?.terrorismCoverage?.deductible !== undefined) ||
          (originalMetadata?.terrorismCoverage?.coverage === true &&
            originalMetadata?.terrorismCoverage?.deductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.terrorismCoverage.deductible !==
                  metadata.terrorismCoverage.deductible,
            }"
            >{{ metadata.terrorismCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.terrorismCoverage.deductible !==
                metadata.terrorismCoverage.deductible &&
              originalMetadata.terrorismCoverage.deductible !== null &&
              originalMetadata.terrorismCoverage.deductible !== undefined
            "
            >{{ originalMetadata.terrorismCoverage.deductible }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isTheftCoverageEmpty(metadata?.theftCoverage) ||
    !isTheftCoverageEmpty(originalMetadata?.theftCoverage)
  "
>
  <div cardTitle i18n>Vol</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.theftCoverage?.theftCoverage !== null &&
            metadata?.theftCoverage?.theftCoverage !== undefined) ||
          (originalMetadata?.theftCoverage?.theftCoverage !== null &&
            originalMetadata?.theftCoverage?.theftCoverage !== undefined)
        "
      >
        <span class="card__label" i18n
          >Vol avec effraction et détournement</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.theftCoverage.theftCoverage
                ) !== getBooleanLabel(metadata.theftCoverage.theftCoverage),
            }"
            >{{ getBooleanLabel(metadata.theftCoverage.theftCoverage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.theftCoverage.theftCoverage) !==
                getBooleanLabel(metadata.theftCoverage.theftCoverage) &&
              getBooleanLabel(originalMetadata.theftCoverage.theftCoverage) !==
                null &&
              getBooleanLabel(originalMetadata.theftCoverage.theftCoverage) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.theftCoverage.theftCoverage)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.theftCoverage?.theftCoverage === true &&
            metadata?.theftCoverage?.insuredSum !== undefined) ||
          (originalMetadata?.theftCoverage?.theftCoverage === true &&
            originalMetadata?.theftCoverage?.insuredSum !== undefined)
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.theftCoverage.insuredSum !==
                  metadata.theftCoverage.insuredSum,
            }"
            >{{ metadata.theftCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.theftCoverage.insuredSum !==
                metadata.theftCoverage.insuredSum &&
              originalMetadata.theftCoverage.insuredSum !== null &&
              originalMetadata.theftCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.theftCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.theftCoverage?.theftCoverage === true &&
            metadata?.theftCoverage?.value !== undefined) ||
          (originalMetadata?.theftCoverage?.theftCoverage === true &&
            originalMetadata?.theftCoverage?.value !== undefined)
        "
      >
        <span class="card__label" i18n>Valeur</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessCompanyThingValueLabel(
                  originalMetadata.theftCoverage.value
                ) !==
                  getBusinessCompanyThingValueLabel(
                    metadata.theftCoverage.value
                  ),
            }"
            >{{
              getBusinessCompanyThingValueLabel(metadata.theftCoverage.value)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.theftCoverage.value
              ) !==
                getBusinessCompanyThingValueLabel(
                  metadata.theftCoverage.value
                ) &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.theftCoverage.value
              ) !== null &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.theftCoverage.value
              ) !== undefined
            "
            >{{
              getBusinessCompanyThingValueLabel(
                originalMetadata.theftCoverage.value
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.theftCoverage?.theftCoverage === true &&
            metadata?.theftCoverage?.deductible !== undefined) ||
          (originalMetadata?.theftCoverage?.theftCoverage === true &&
            originalMetadata?.theftCoverage?.deductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.theftCoverage.deductible !==
                  metadata.theftCoverage.deductible,
            }"
            >{{ metadata.theftCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.theftCoverage.deductible !==
                metadata.theftCoverage.deductible &&
              originalMetadata.theftCoverage.deductible !== null &&
              originalMetadata.theftCoverage.deductible !== undefined
            "
            >{{ originalMetadata.theftCoverage.deductible }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.theftCoverage?.theftCoverage === true &&
            metadata?.theftCoverage?.specialFees !== undefined) ||
          (originalMetadata?.theftCoverage?.theftCoverage === true &&
            originalMetadata?.theftCoverage?.specialFees !== undefined)
        "
      >
        <span class="card__label" i18n>Choses spéciales et frais</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.theftCoverage.specialFees !==
                  metadata.theftCoverage.specialFees,
            }"
            >{{ metadata.theftCoverage.specialFees }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.theftCoverage.specialFees !==
                metadata.theftCoverage.specialFees &&
              originalMetadata.theftCoverage.specialFees !== null &&
              originalMetadata.theftCoverage.specialFees !== undefined
            "
            >{{ originalMetadata.theftCoverage.specialFees }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.theftCoverage?.theftCoverage === true &&
            metadata?.theftCoverage?.contingencyInsurance !== undefined) ||
          (originalMetadata?.theftCoverage?.theftCoverage === true &&
            originalMetadata?.theftCoverage?.contingencyInsurance !== undefined)
        "
      >
        <span class="card__label" i18n>Assurance prévisionnelle</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.theftCoverage.contingencyInsurance !==
                  metadata.theftCoverage.contingencyInsurance,
            }"
            >{{ metadata.theftCoverage.contingencyInsurance }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.theftCoverage.contingencyInsurance !==
                metadata.theftCoverage.contingencyInsurance &&
              originalMetadata.theftCoverage.contingencyInsurance !== null &&
              originalMetadata.theftCoverage.contingencyInsurance !== undefined
            "
            >{{ originalMetadata.theftCoverage.contingencyInsurance }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.theftCoverage?.theftCoverage === true &&
            metadata?.theftCoverage?.externalInsurance !== undefined) ||
          (originalMetadata?.theftCoverage?.theftCoverage === true &&
            originalMetadata?.theftCoverage?.externalInsurance !== undefined)
        "
      >
        <span class="card__label" i18n>Assurance externe</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.theftCoverage.externalInsurance !==
                  metadata.theftCoverage.externalInsurance,
            }"
            >{{ metadata.theftCoverage.externalInsurance }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.theftCoverage.externalInsurance !==
                metadata.theftCoverage.externalInsurance &&
              originalMetadata.theftCoverage.externalInsurance !== null &&
              originalMetadata.theftCoverage.externalInsurance !== undefined
            "
            >{{ originalMetadata.theftCoverage.externalInsurance }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.theftCoverage?.theftCoverage === true &&
            metadata?.theftCoverage?.constructionHutTools !== undefined) ||
          (originalMetadata?.theftCoverage?.theftCoverage === true &&
            originalMetadata?.theftCoverage?.constructionHutTools !== undefined)
        "
      >
        <span class="card__label" i18n>Outils dans baraques de chantier</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.theftCoverage.constructionHutTools !==
                  metadata.theftCoverage.constructionHutTools,
            }"
            >{{ metadata.theftCoverage.constructionHutTools }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.theftCoverage.constructionHutTools !==
                metadata.theftCoverage.constructionHutTools &&
              originalMetadata.theftCoverage.constructionHutTools !== null &&
              originalMetadata.theftCoverage.constructionHutTools !== undefined
            "
            >{{ originalMetadata.theftCoverage.constructionHutTools }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.theftCoverage?.theftCoverage === true &&
            metadata?.theftCoverage?.monetaryValues !== undefined) ||
          (originalMetadata?.theftCoverage?.theftCoverage === true &&
            originalMetadata?.theftCoverage?.monetaryValues !== undefined)
        "
      >
        <span class="card__label" i18n>Valeurs pécuniaires</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.theftCoverage.monetaryValues !==
                  metadata.theftCoverage.monetaryValues,
            }"
            >{{ metadata.theftCoverage.monetaryValues }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.theftCoverage.monetaryValues !==
                metadata.theftCoverage.monetaryValues &&
              originalMetadata.theftCoverage.monetaryValues !== null &&
              originalMetadata.theftCoverage.monetaryValues !== undefined
            "
            >{{ originalMetadata.theftCoverage.monetaryValues }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.theftCoverage?.theftCoverage === true &&
            metadata?.theftCoverage?.monetaryValuesInSafe !== undefined) ||
          (originalMetadata?.theftCoverage?.theftCoverage === true &&
            originalMetadata?.theftCoverage?.monetaryValuesInSafe !== undefined)
        "
      >
        <span class="card__label" i18n
          >Valeurs pécuniaires dans les coffres-forts</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.theftCoverage.monetaryValuesInSafe !==
                  metadata.theftCoverage.monetaryValuesInSafe,
            }"
            >{{ metadata.theftCoverage.monetaryValuesInSafe }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.theftCoverage.monetaryValuesInSafe !==
                metadata.theftCoverage.monetaryValuesInSafe &&
              originalMetadata.theftCoverage.monetaryValuesInSafe !== null &&
              originalMetadata.theftCoverage.monetaryValuesInSafe !== undefined
            "
            >{{ originalMetadata.theftCoverage.monetaryValuesInSafe }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isBasicCoverageEmpty(metadata?.breakageCoverage) ||
    !isBasicCoverageEmpty(originalMetadata?.breakageCoverage)
  "
>
  <div cardTitle i18n>Bris de glace</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.breakageCoverage?.coverage !== null &&
            metadata?.breakageCoverage?.coverage !== undefined) ||
          (originalMetadata?.breakageCoverage?.coverage !== null &&
            originalMetadata?.breakageCoverage?.coverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture bris de glace</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.breakageCoverage.coverage) !==
                  getBooleanLabel(metadata.breakageCoverage.coverage),
            }"
            >{{ getBooleanLabel(metadata.breakageCoverage.coverage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.breakageCoverage.coverage) !==
                getBooleanLabel(metadata.breakageCoverage.coverage) &&
              getBooleanLabel(originalMetadata.breakageCoverage.coverage) !==
                null &&
              getBooleanLabel(originalMetadata.breakageCoverage.coverage) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.breakageCoverage.coverage)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.breakageCoverage?.coverage === true &&
            metadata?.breakageCoverage?.insuredSum !== undefined) ||
          (originalMetadata?.breakageCoverage?.coverage === true &&
            originalMetadata?.breakageCoverage?.insuredSum !== undefined)
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.breakageCoverage.insuredSum !==
                  metadata.breakageCoverage.insuredSum,
            }"
            >{{ metadata.breakageCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.breakageCoverage.insuredSum !==
                metadata.breakageCoverage.insuredSum &&
              originalMetadata.breakageCoverage.insuredSum !== null &&
              originalMetadata.breakageCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.breakageCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.breakageCoverage?.coverage === true &&
            metadata?.breakageCoverage?.value !== undefined) ||
          (originalMetadata?.breakageCoverage?.coverage === true &&
            originalMetadata?.breakageCoverage?.value !== undefined)
        "
      >
        <span class="card__label" i18n>Valeur</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessCompanyThingValueLabel(
                  originalMetadata.breakageCoverage.value
                ) !==
                  getBusinessCompanyThingValueLabel(
                    metadata.breakageCoverage.value
                  ),
            }"
            >{{
              getBusinessCompanyThingValueLabel(metadata.breakageCoverage.value)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.breakageCoverage.value
              ) !==
                getBusinessCompanyThingValueLabel(
                  metadata.breakageCoverage.value
                ) &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.breakageCoverage.value
              ) !== null &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.breakageCoverage.value
              ) !== undefined
            "
            >{{
              getBusinessCompanyThingValueLabel(
                originalMetadata.breakageCoverage.value
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.breakageCoverage?.coverage === true &&
            metadata?.breakageCoverage?.deductible !== undefined) ||
          (originalMetadata?.breakageCoverage?.coverage === true &&
            originalMetadata?.breakageCoverage?.deductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.breakageCoverage.deductible !==
                  metadata.breakageCoverage.deductible,
            }"
            >{{ metadata.breakageCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.breakageCoverage.deductible !==
                metadata.breakageCoverage.deductible &&
              originalMetadata.breakageCoverage.deductible !== null &&
              originalMetadata.breakageCoverage.deductible !== undefined
            "
            >{{ originalMetadata.breakageCoverage.deductible }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isWaterDamageCoverageEmpty(metadata?.waterDamageCoverage) ||
    !isWaterDamageCoverageEmpty(originalMetadata?.waterDamageCoverage)
  "
>
  <div cardTitle i18n>Dégâts des eaux</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.waterDamageCoverage?.waterDamageCoverage !== null &&
            metadata?.waterDamageCoverage?.waterDamageCoverage !== undefined) ||
          (originalMetadata?.waterDamageCoverage?.waterDamageCoverage !==
            null &&
            originalMetadata?.waterDamageCoverage?.waterDamageCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Dégâts des eaux</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.waterDamageCoverage.waterDamageCoverage
                ) !==
                  getBooleanLabel(
                    metadata.waterDamageCoverage.waterDamageCoverage
                  ),
            }"
            >{{
              getBooleanLabel(metadata.waterDamageCoverage.waterDamageCoverage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.waterDamageCoverage.waterDamageCoverage
              ) !==
                getBooleanLabel(
                  metadata.waterDamageCoverage.waterDamageCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.waterDamageCoverage.waterDamageCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.waterDamageCoverage.waterDamageCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.waterDamageCoverage.waterDamageCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.waterDamageCoverage?.waterDamageCoverage === true &&
            metadata?.waterDamageCoverage?.insuredSum !== undefined) ||
          (originalMetadata?.waterDamageCoverage?.waterDamageCoverage ===
            true &&
            originalMetadata?.waterDamageCoverage?.insuredSum !== undefined)
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.waterDamageCoverage.insuredSum !==
                  metadata.waterDamageCoverage.insuredSum,
            }"
            >{{ metadata.waterDamageCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.waterDamageCoverage.insuredSum !==
                metadata.waterDamageCoverage.insuredSum &&
              originalMetadata.waterDamageCoverage.insuredSum !== null &&
              originalMetadata.waterDamageCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.waterDamageCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.waterDamageCoverage?.waterDamageCoverage === true &&
            metadata?.waterDamageCoverage?.value !== undefined) ||
          (originalMetadata?.waterDamageCoverage?.waterDamageCoverage ===
            true &&
            originalMetadata?.waterDamageCoverage?.value !== undefined)
        "
      >
        <span class="card__label" i18n>Valeur</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessCompanyThingValueLabel(
                  originalMetadata.waterDamageCoverage.value
                ) !==
                  getBusinessCompanyThingValueLabel(
                    metadata.waterDamageCoverage.value
                  ),
            }"
            >{{
              getBusinessCompanyThingValueLabel(
                metadata.waterDamageCoverage.value
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.waterDamageCoverage.value
              ) !==
                getBusinessCompanyThingValueLabel(
                  metadata.waterDamageCoverage.value
                ) &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.waterDamageCoverage.value
              ) !== null &&
              getBusinessCompanyThingValueLabel(
                originalMetadata.waterDamageCoverage.value
              ) !== undefined
            "
            >{{
              getBusinessCompanyThingValueLabel(
                originalMetadata.waterDamageCoverage.value
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.waterDamageCoverage?.waterDamageCoverage === true &&
            metadata?.waterDamageCoverage?.deductible !== undefined) ||
          (originalMetadata?.waterDamageCoverage?.waterDamageCoverage ===
            true &&
            originalMetadata?.waterDamageCoverage?.deductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.waterDamageCoverage.deductible !==
                  metadata.waterDamageCoverage.deductible,
            }"
            >{{ metadata.waterDamageCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.waterDamageCoverage.deductible !==
                metadata.waterDamageCoverage.deductible &&
              originalMetadata.waterDamageCoverage.deductible !== null &&
              originalMetadata.waterDamageCoverage.deductible !== undefined
            "
            >{{ originalMetadata.waterDamageCoverage.deductible }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.waterDamageCoverage?.waterDamageCoverage === true &&
            metadata?.waterDamageCoverage?.specialFees !== undefined) ||
          (originalMetadata?.waterDamageCoverage?.waterDamageCoverage ===
            true &&
            originalMetadata?.waterDamageCoverage?.specialFees !== undefined)
        "
      >
        <span class="card__label" i18n>Choses spéciales et frais</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.waterDamageCoverage.specialFees !==
                  metadata.waterDamageCoverage.specialFees,
            }"
            >{{ metadata.waterDamageCoverage.specialFees }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.waterDamageCoverage.specialFees !==
                metadata.waterDamageCoverage.specialFees &&
              originalMetadata.waterDamageCoverage.specialFees !== null &&
              originalMetadata.waterDamageCoverage.specialFees !== undefined
            "
            >{{ originalMetadata.waterDamageCoverage.specialFees }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.waterDamageCoverage?.waterDamageCoverage === true &&
            metadata?.waterDamageCoverage?.contingencyInsurance !==
              undefined) ||
          (originalMetadata?.waterDamageCoverage?.waterDamageCoverage ===
            true &&
            originalMetadata?.waterDamageCoverage?.contingencyInsurance !==
              undefined)
        "
      >
        <span class="card__label" i18n>Assurance prévisionnelle</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.waterDamageCoverage.contingencyInsurance !==
                  metadata.waterDamageCoverage.contingencyInsurance,
            }"
            >{{ metadata.waterDamageCoverage.contingencyInsurance }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.waterDamageCoverage.contingencyInsurance !==
                metadata.waterDamageCoverage.contingencyInsurance &&
              originalMetadata.waterDamageCoverage.contingencyInsurance !==
                null &&
              originalMetadata.waterDamageCoverage.contingencyInsurance !==
                undefined
            "
            >{{
              originalMetadata.waterDamageCoverage.contingencyInsurance
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.waterDamageCoverage?.waterDamageCoverage === true &&
            metadata?.waterDamageCoverage?.externalInsurance !== undefined) ||
          (originalMetadata?.waterDamageCoverage?.waterDamageCoverage ===
            true &&
            originalMetadata?.waterDamageCoverage?.externalInsurance !==
              undefined)
        "
      >
        <span class="card__label" i18n>Assurance externe</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.waterDamageCoverage.externalInsurance !==
                  metadata.waterDamageCoverage.externalInsurance,
            }"
            >{{ metadata.waterDamageCoverage.externalInsurance }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.waterDamageCoverage.externalInsurance !==
                metadata.waterDamageCoverage.externalInsurance &&
              originalMetadata.waterDamageCoverage.externalInsurance !== null &&
              originalMetadata.waterDamageCoverage.externalInsurance !==
                undefined
            "
            >{{ originalMetadata.waterDamageCoverage.externalInsurance }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.waterDamageCoverage?.waterDamageCoverage === true &&
            metadata?.waterDamageCoverage?.constructionHutTools !==
              undefined) ||
          (originalMetadata?.waterDamageCoverage?.waterDamageCoverage ===
            true &&
            originalMetadata?.waterDamageCoverage?.constructionHutTools !==
              undefined)
        "
      >
        <span class="card__label" i18n>Outils dans baraques de chantier</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.waterDamageCoverage.constructionHutTools !==
                  metadata.waterDamageCoverage.constructionHutTools,
            }"
            >{{ metadata.waterDamageCoverage.constructionHutTools }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.waterDamageCoverage.constructionHutTools !==
                metadata.waterDamageCoverage.constructionHutTools &&
              originalMetadata.waterDamageCoverage.constructionHutTools !==
                null &&
              originalMetadata.waterDamageCoverage.constructionHutTools !==
                undefined
            "
            >{{
              originalMetadata.waterDamageCoverage.constructionHutTools
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isEpidemicCoverageEmpty(metadata?.epidemicCoverage) ||
    !isEpidemicCoverageEmpty(originalMetadata?.epidemicCoverage)
  "
>
  <div cardTitle i18n>Épidémie</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.epidemicCoverage?.pandemicIncluded !== null &&
            metadata?.epidemicCoverage?.pandemicIncluded !== undefined) ||
          (originalMetadata?.epidemicCoverage?.pandemicIncluded !== null &&
            originalMetadata?.epidemicCoverage?.pandemicIncluded !== undefined)
        "
      >
        <span class="card__label" i18n>Pandémie incluse</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.epidemicCoverage.pandemicIncluded
                ) !==
                  getBooleanLabel(metadata.epidemicCoverage.pandemicIncluded),
            }"
            >{{
              getBooleanLabel(metadata.epidemicCoverage.pandemicIncluded)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.epidemicCoverage.pandemicIncluded
              ) !==
                getBooleanLabel(metadata.epidemicCoverage.pandemicIncluded) &&
              getBooleanLabel(
                originalMetadata.epidemicCoverage.pandemicIncluded
              ) !== null &&
              getBooleanLabel(
                originalMetadata.epidemicCoverage.pandemicIncluded
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.epidemicCoverage.pandemicIncluded
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.epidemicCoverage?.pandemicIncluded === true &&
            metadata?.epidemicCoverage?.insuredSum !== undefined) ||
          (originalMetadata?.epidemicCoverage?.pandemicIncluded === true &&
            originalMetadata?.epidemicCoverage?.insuredSum !== undefined)
        "
      >
        <span class="card__label" i18n>Somme d'assurance (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.epidemicCoverage.insuredSum !==
                  metadata.epidemicCoverage.insuredSum,
            }"
            >{{ metadata.epidemicCoverage.insuredSum }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.epidemicCoverage.insuredSum !==
                metadata.epidemicCoverage.insuredSum &&
              originalMetadata.epidemicCoverage.insuredSum !== null &&
              originalMetadata.epidemicCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.epidemicCoverage.insuredSum }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.epidemicCoverage?.pandemicIncluded === true &&
            metadata?.epidemicCoverage?.deductible !== undefined) ||
          (originalMetadata?.epidemicCoverage?.pandemicIncluded === true &&
            originalMetadata?.epidemicCoverage?.deductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.epidemicCoverage.deductible !==
                  metadata.epidemicCoverage.deductible,
            }"
            >{{ metadata.epidemicCoverage.deductible }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.epidemicCoverage.deductible !==
                metadata.epidemicCoverage.deductible &&
              originalMetadata.epidemicCoverage.deductible !== null &&
              originalMetadata.epidemicCoverage.deductible !== undefined
            "
            >{{ originalMetadata.epidemicCoverage.deductible }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.epidemicCoverage?.pandemicIncluded === true &&
            metadata?.epidemicCoverage?.duration !== undefined) ||
          (originalMetadata?.epidemicCoverage?.pandemicIncluded === true &&
            originalMetadata?.epidemicCoverage?.duration !== undefined)
        "
      >
        <span class="card__label" i18n>Durée</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.epidemicCoverage.duration !==
                  metadata.epidemicCoverage.duration,
            }"
            >{{ metadata.epidemicCoverage.duration }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.epidemicCoverage.duration !==
                metadata.epidemicCoverage.duration &&
              originalMetadata.epidemicCoverage.duration !== null &&
              originalMetadata.epidemicCoverage.duration !== undefined
            "
            >{{ originalMetadata.epidemicCoverage.duration }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isTechnicalCoverageEmpty(metadata?.technicalCoverage) ||
    !isTechnicalCoverageEmpty(originalMetadata?.technicalCoverage)
  "
>
  <div cardTitle i18n>Couverture Technique</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.technicalCoverage?.technicalCoverage !== null &&
            metadata?.technicalCoverage?.technicalCoverage !== undefined) ||
          (originalMetadata?.technicalCoverage?.technicalCoverage !== null &&
            originalMetadata?.technicalCoverage?.technicalCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture technique</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.technicalCoverage.technicalCoverage
                ) !==
                  getBooleanLabel(metadata.technicalCoverage.technicalCoverage),
            }"
            >{{
              getBooleanLabel(metadata.technicalCoverage.technicalCoverage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.technicalCoverage.technicalCoverage
              ) !==
                getBooleanLabel(metadata.technicalCoverage.technicalCoverage) &&
              getBooleanLabel(
                originalMetadata.technicalCoverage.technicalCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.technicalCoverage.technicalCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.technicalCoverage.technicalCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.technicalCoverage?.technicalCoverage === true &&
            metadata?.technicalCoverage?.insuredSum !== undefined) ||
          (originalMetadata?.technicalCoverage?.technicalCoverage === true &&
            originalMetadata?.technicalCoverage?.insuredSum !== undefined)
        "
      >
        <span class="card__label" i18n>Somme d'assurance (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.technicalCoverage.insuredSum !==
                  metadata.technicalCoverage.insuredSum,
            }"
            >{{ metadata.technicalCoverage.insuredSum }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.technicalCoverage.insuredSum !==
                metadata.technicalCoverage.insuredSum &&
              originalMetadata.technicalCoverage.insuredSum !== null &&
              originalMetadata.technicalCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.technicalCoverage.insuredSum }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.technicalCoverage?.technicalCoverage === true &&
            metadata?.technicalCoverage?.deductible !== undefined) ||
          (originalMetadata?.technicalCoverage?.technicalCoverage === true &&
            originalMetadata?.technicalCoverage?.deductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.technicalCoverage.deductible !==
                  metadata.technicalCoverage.deductible,
            }"
            >{{ metadata.technicalCoverage.deductible }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.technicalCoverage.deductible !==
                metadata.technicalCoverage.deductible &&
              originalMetadata.technicalCoverage.deductible !== null &&
              originalMetadata.technicalCoverage.deductible !== undefined
            "
            >{{ originalMetadata.technicalCoverage.deductible }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.technicalCoverage?.technicalCoverage === true &&
            metadata?.technicalCoverage?.insuranceType !== undefined) ||
          (originalMetadata?.technicalCoverage?.technicalCoverage === true &&
            originalMetadata?.technicalCoverage?.insuranceType !== undefined)
        "
      >
        <span class="card__label" i18n>Type d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.technicalCoverage.insuranceType !==
                  metadata.technicalCoverage.insuranceType,
            }"
            >{{ metadata.technicalCoverage.insuranceType }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.technicalCoverage.insuranceType !==
                metadata.technicalCoverage.insuranceType &&
              originalMetadata.technicalCoverage.insuranceType !== null &&
              originalMetadata.technicalCoverage.insuranceType !== undefined
            "
            >{{ originalMetadata.technicalCoverage.insuranceType }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isLossCoverageEmpty(metadata?.lossCoverage) ||
    !isLossCoverageEmpty(originalMetadata?.lossCoverage)
  "
>
  <div cardTitle i18n>Pertes d'Exploitation</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage !== null &&
            metadata?.lossCoverage?.lossCoverage !== undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage !== null &&
            originalMetadata?.lossCoverage?.lossCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Pertes d'exploitation</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.lossCoverage.lossCoverage) !==
                  getBooleanLabel(metadata.lossCoverage.lossCoverage),
            }"
            >{{ getBooleanLabel(metadata.lossCoverage.lossCoverage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.lossCoverage.lossCoverage) !==
                getBooleanLabel(metadata.lossCoverage.lossCoverage) &&
              getBooleanLabel(originalMetadata.lossCoverage.lossCoverage) !==
                null &&
              getBooleanLabel(originalMetadata.lossCoverage.lossCoverage) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.lossCoverage.lossCoverage)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage === true &&
            metadata?.lossCoverage?.fireNaturalDisasterCoverage !== null &&
            metadata?.lossCoverage?.fireNaturalDisasterCoverage !==
              undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage === true &&
            originalMetadata?.lossCoverage?.fireNaturalDisasterCoverage !==
              null &&
            originalMetadata?.lossCoverage?.fireNaturalDisasterCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Incendie et événements naturels</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.lossCoverage.fireNaturalDisasterCoverage
                ) !==
                  getBooleanLabel(
                    metadata.lossCoverage.fireNaturalDisasterCoverage
                  ),
            }"
            >{{
              getBooleanLabel(metadata.lossCoverage.fireNaturalDisasterCoverage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.lossCoverage.fireNaturalDisasterCoverage
              ) !==
                getBooleanLabel(
                  metadata.lossCoverage.fireNaturalDisasterCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.lossCoverage.fireNaturalDisasterCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.lossCoverage.fireNaturalDisasterCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.lossCoverage.fireNaturalDisasterCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage === true &&
            metadata?.lossCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.lossCoverage?.fireInsuredSum !== undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage === true &&
            originalMetadata?.lossCoverage?.fireNaturalDisasterCoverage ===
              true &&
            originalMetadata?.lossCoverage?.fireInsuredSum !== undefined)
        "
      >
        <span class="card__label" i18n>Somme d'assurance incendie</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.lossCoverage.fireInsuredSum !==
                  metadata.lossCoverage.fireInsuredSum,
            }"
            >{{ metadata.lossCoverage.fireInsuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.lossCoverage.fireInsuredSum !==
                metadata.lossCoverage.fireInsuredSum &&
              originalMetadata.lossCoverage.fireInsuredSum !== null &&
              originalMetadata.lossCoverage.fireInsuredSum !== undefined
            "
            >{{ originalMetadata.lossCoverage.fireInsuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage === true &&
            metadata?.lossCoverage?.fireNaturalDisasterCoverage === true &&
            metadata?.lossCoverage?.fireDeductible !== undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage === true &&
            originalMetadata?.lossCoverage?.fireNaturalDisasterCoverage ===
              true &&
            originalMetadata?.lossCoverage?.fireDeductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise incendie</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.lossCoverage.fireDeductible !==
                  metadata.lossCoverage.fireDeductible,
            }"
            >{{ metadata.lossCoverage.fireDeductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.lossCoverage.fireDeductible !==
                metadata.lossCoverage.fireDeductible &&
              originalMetadata.lossCoverage.fireDeductible !== null &&
              originalMetadata.lossCoverage.fireDeductible !== undefined
            "
            >{{ originalMetadata.lossCoverage.fireDeductible }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage === true &&
            metadata?.lossCoverage?.theftCoverage !== null &&
            metadata?.lossCoverage?.theftCoverage !== undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage === true &&
            originalMetadata?.lossCoverage?.theftCoverage !== null &&
            originalMetadata?.lossCoverage?.theftCoverage !== undefined)
        "
      >
        <span class="card__label" i18n
          >Vol avec effraction et détournement</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.lossCoverage.theftCoverage) !==
                  getBooleanLabel(metadata.lossCoverage.theftCoverage),
            }"
            >{{ getBooleanLabel(metadata.lossCoverage.theftCoverage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.lossCoverage.theftCoverage) !==
                getBooleanLabel(metadata.lossCoverage.theftCoverage) &&
              getBooleanLabel(originalMetadata.lossCoverage.theftCoverage) !==
                null &&
              getBooleanLabel(originalMetadata.lossCoverage.theftCoverage) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.lossCoverage.theftCoverage)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage === true &&
            metadata?.lossCoverage?.theftCoverage === true &&
            metadata?.lossCoverage?.theftInsuredSum !== undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage === true &&
            originalMetadata?.lossCoverage?.theftCoverage === true &&
            originalMetadata?.lossCoverage?.theftInsuredSum !== undefined)
        "
      >
        <span class="card__label" i18n>Somme d'assurance vol</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.lossCoverage.theftInsuredSum !==
                  metadata.lossCoverage.theftInsuredSum,
            }"
            >{{ metadata.lossCoverage.theftInsuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.lossCoverage.theftInsuredSum !==
                metadata.lossCoverage.theftInsuredSum &&
              originalMetadata.lossCoverage.theftInsuredSum !== null &&
              originalMetadata.lossCoverage.theftInsuredSum !== undefined
            "
            >{{ originalMetadata.lossCoverage.theftInsuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage === true &&
            metadata?.lossCoverage?.theftCoverage === true &&
            metadata?.lossCoverage?.theftDeductible !== undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage === true &&
            originalMetadata?.lossCoverage?.theftCoverage === true &&
            originalMetadata?.lossCoverage?.theftDeductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise vol</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.lossCoverage.theftDeductible !==
                  metadata.lossCoverage.theftDeductible,
            }"
            >{{ metadata.lossCoverage.theftDeductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.lossCoverage.theftDeductible !==
                metadata.lossCoverage.theftDeductible &&
              originalMetadata.lossCoverage.theftDeductible !== null &&
              originalMetadata.lossCoverage.theftDeductible !== undefined
            "
            >{{ originalMetadata.lossCoverage.theftDeductible }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage === true &&
            metadata?.lossCoverage?.waterDamageCoverage !== null &&
            metadata?.lossCoverage?.waterDamageCoverage !== undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage === true &&
            originalMetadata?.lossCoverage?.waterDamageCoverage !== null &&
            originalMetadata?.lossCoverage?.waterDamageCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Dégâts des eaux</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.lossCoverage.waterDamageCoverage
                ) !==
                  getBooleanLabel(metadata.lossCoverage.waterDamageCoverage),
            }"
            >{{
              getBooleanLabel(metadata.lossCoverage.waterDamageCoverage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.lossCoverage.waterDamageCoverage
              ) !==
                getBooleanLabel(metadata.lossCoverage.waterDamageCoverage) &&
              getBooleanLabel(
                originalMetadata.lossCoverage.waterDamageCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.lossCoverage.waterDamageCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata.lossCoverage.waterDamageCoverage)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage === true &&
            metadata?.lossCoverage?.waterDamageCoverage === true &&
            metadata?.lossCoverage?.waterInsuredSum !== undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage === true &&
            originalMetadata?.lossCoverage?.waterDamageCoverage === true &&
            originalMetadata?.lossCoverage?.waterInsuredSum !== undefined)
        "
      >
        <span class="card__label" i18n>Somme d'assurance dégâts des eaux</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.lossCoverage.waterInsuredSum !==
                  metadata.lossCoverage.waterInsuredSum,
            }"
            >{{ metadata.lossCoverage.waterInsuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.lossCoverage.waterInsuredSum !==
                metadata.lossCoverage.waterInsuredSum &&
              originalMetadata.lossCoverage.waterInsuredSum !== null &&
              originalMetadata.lossCoverage.waterInsuredSum !== undefined
            "
            >{{ originalMetadata.lossCoverage.waterInsuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage === true &&
            metadata?.lossCoverage?.waterDamageCoverage === true &&
            metadata?.lossCoverage?.waterDeductible !== undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage === true &&
            originalMetadata?.lossCoverage?.waterDamageCoverage === true &&
            originalMetadata?.lossCoverage?.waterDeductible !== undefined)
        "
      >
        <span class="card__label" i18n>Franchise dégâts des eaux</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.lossCoverage.waterDeductible !==
                  metadata.lossCoverage.waterDeductible,
            }"
            >{{ metadata.lossCoverage.waterDeductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.lossCoverage.waterDeductible !==
                metadata.lossCoverage.waterDeductible &&
              originalMetadata.lossCoverage.waterDeductible !== null &&
              originalMetadata.lossCoverage.waterDeductible !== undefined
            "
            >{{ originalMetadata.lossCoverage.waterDeductible }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage === true &&
            metadata?.lossCoverage?.revenue !== undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage === true &&
            originalMetadata?.lossCoverage?.revenue !== undefined)
        "
      >
        <span class="card__label" i18n>Chiffre d'affaires</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.lossCoverage.revenue !==
                  metadata.lossCoverage.revenue,
            }"
            >{{ metadata.lossCoverage.revenue }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.lossCoverage.revenue !==
                metadata.lossCoverage.revenue &&
              originalMetadata.lossCoverage.revenue !== null &&
              originalMetadata.lossCoverage.revenue !== undefined
            "
            >{{ originalMetadata.lossCoverage.revenue }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.lossCoverage?.lossCoverage === true &&
            metadata?.lossCoverage?.grossInsuranceProfit !== undefined) ||
          (originalMetadata?.lossCoverage?.lossCoverage === true &&
            originalMetadata?.lossCoverage?.grossInsuranceProfit !== undefined)
        "
      >
        <span class="card__label" i18n>Bénéfice brut d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.lossCoverage.grossInsuranceProfit !==
                  metadata.lossCoverage.grossInsuranceProfit,
            }"
            >{{ metadata.lossCoverage.grossInsuranceProfit }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.lossCoverage.grossInsuranceProfit !==
                metadata.lossCoverage.grossInsuranceProfit &&
              originalMetadata.lossCoverage.grossInsuranceProfit !== null &&
              originalMetadata.lossCoverage.grossInsuranceProfit !== undefined
            "
            >{{ originalMetadata.lossCoverage.grossInsuranceProfit }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card class="flex-basis-100 mb-12" *ngIf="hasCurrentInsuranceInfo()">
  <div cardTitle i18n>Assurance actuelle</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasInsurance !== null &&
            metadata?.hasInsurance !== undefined) ||
          (originalMetadata?.hasInsurance !== null &&
            originalMetadata?.hasInsurance !== undefined)
        "
      >
        <span class="card__label" i18n>Possède une assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasInsurance) !==
                  getBooleanLabel(metadata.hasInsurance),
            }"
            >{{ getBooleanLabel(metadata.hasInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasInsurance) !==
                getBooleanLabel(metadata.hasInsurance) &&
              getBooleanLabel(originalMetadata.hasInsurance) !== null &&
              getBooleanLabel(originalMetadata.hasInsurance) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.hasInsurance) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.currentInsurer || originalMetadata?.currentInsurer"
      >
        <span class="card__label" i18n>Assureur actuel</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.currentInsurer !== metadata.currentInsurer,
            }"
            >{{ metadata.currentInsurer }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.currentInsurer !== metadata.currentInsurer &&
              originalMetadata.currentInsurer !== null &&
              originalMetadata.currentInsurer !== undefined
            "
            >{{ originalMetadata.currentInsurer }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasClaimsLastFiveYears !== null &&
            metadata?.hasClaimsLastFiveYears !== undefined) ||
          (originalMetadata?.hasClaimsLastFiveYears !== null &&
            originalMetadata?.hasClaimsLastFiveYears !== undefined)
        "
      >
        <span class="card__label" i18n
          >A subi des sinistres ces 5 dernières années</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                  getBooleanLabel(metadata.hasClaimsLastFiveYears),
            }"
            >{{ getBooleanLabel(metadata.hasClaimsLastFiveYears) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                getBooleanLabel(metadata.hasClaimsLastFiveYears) &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                null &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
